<div class="real-cost-container">
  <div *ngIf="!hasPageAccess" class="access-warning">
    <span>&#9888; You don't have permission to access this page. Please contact your administrator.</span>
  </div>
  <div class="filter-view">
    <div class="filter-header">
      <h2>Filters</h2>
      <span *ngIf="invoicePreviewCode && canSeeMultipliersGrid" class="invoice-preview-label">Invoice Preview Code: {{ invoicePreviewCode }}<ng-container *ngIf="invoicePreviewCreatedAt"> - Date: {{ invoicePreviewCreatedAt }}</ng-container></span>
    </div>
    <!-- Project Engineer -->
    <dx-autocomplete placeholder="Contract..."
                     class="search-width"
                     [dataSource]="contracts"
                     itemTemplate="searchItem"
                     valueExpr="name"
                     [grouped]="true"
                     groupTemplate="groupTemplate"
                     [searchTimeout]="1000"
                     #autoComplComponent
                     (onEnterKey)="onKeyDown($event, autoComplComponent)">
      <div *dxTemplate="let data of 'groupTemplate'" class="group_header">
        <div>{{ data.key }}</div>
        </div>
      <div *dxTemplate="let item of 'searchItem'"
           class="autocomplete_list_item"
           (click)="redirectToSelectedItem(item, autoComplComponent)">
        <div class="autocomplete_list_item_layout">
          <div class="autocomplete_list_item_text">
            <span><strong>Code</strong>: {{ item.code }}</span>
          </div>
          <div class="autocomplete_list_item_text">
            <span class="max-width">
              <strong>Name</strong>:
              {{ item.name }}
            </span>
            <span class="max-width">
              <strong>Customer</strong>:
              {{ item.customer }}
            </span>
          </div>
        </div>
      </div>
    </dx-autocomplete>
  </div>

  <div class="report-view" *ngIf="canSeeMultipliersGrid">
    <dx-data-grid #multipliersGrid
                  [dataSource]="gridMultipliers"
                  [rowAlternationEnabled]="true"
                  [showBorders]="true"
                  [showColumnLines]="true"
                  [showRowLines]="true"
                  (onRowUpdated)="onMultiplierEdit($event)"
                  id="gridContainer">
      <dxo-sorting mode="none"></dxo-sorting>
      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column caption="Contract"
                  dataField="contract"
                  [allowEditing]="false">
      </dxi-column>
      <dxi-column caption="Milestone"
                  dataField="milestone"
                  cssClass="milestone-cell"
                  [allowEditing]="false">
      </dxi-column>
      <dxi-column caption="Task"
                  dataField="task"
                  [allowEditing]="false">
      </dxi-column>
      <dxi-column caption="Multiplier 1"
                  dataField="mult1"
                  dataType="number"
                  cellTemplate="mult1Template"
                  [allowEditing]="true">
        <dxo-form-item [editorOptions]="{ step: 0.0001, min: 0.0001 }"></dxo-form-item>
      </dxi-column>
      <dxi-column caption="Multiplier 2"
                  dataField="mult2"
                  dataType="number"
                  cellTemplate="mult2Template"
                  [allowEditing]="true">
        <dxo-form-item [editorOptions]="{ step: 0.0001, min: 0.0001 }"></dxo-form-item>
      </dxi-column>
      <dxi-column caption="Multiplier 3"
                  dataField="mult3"
                  dataType="number"
                  cellTemplate="mult3Template"
                  [allowEditing]="true">
        <dxo-form-item [editorOptions]="{ step: 0.0001, min: 0.0001 }"></dxo-form-item>
      </dxi-column>
      <dxi-column caption=""
                  cellTemplate="actionsTemplate"
                  [allowEditing]="false"
                  [width]="80">
      </dxi-column>
      
      <div *dxTemplate="let row of 'actionsTemplate'" class="action-icons">
        <!-- Green Arrow Down: Show only for Contract and Milestone rows that have multiplier values -->
        <i *ngIf="(row.data.isContractHeader || row.data.isMilestoneHeader) && hasMultiplierValues(row.data)"
           class="dx-icon dx-icon-arrowdown action-icon green-arrow"
           (click)="onClearChildren(row.data)"
           title="Clear all child rows' multipliers">
        </i>
        
        <!-- Red X: Show if any multiplier has a value -->
        <i *ngIf="hasMultiplierValues(row.data)"
           class="dx-icon dx-icon-close action-icon red-cross"
           (click)="onClearMultipliers(row.data)"
           title="Reset multipliers">
        </i>
      </div>

      <div *dxTemplate="let data of 'mult1Template'">
        {{ data.value != null ? (data.value | number:'1.0-4') : '-' }}
      </div>

      <div *dxTemplate="let data of 'mult2Template'">
        {{ data.value != null ? (data.value | number:'1.0-4') : '-' }}
      </div>

      <div *dxTemplate="let data of 'mult3Template'">
        {{ data.value != null ? (data.value | number:'1.0-4') : '-' }}
      </div>
      
      <dxo-editing
        mode="cell"
        [allowUpdating]="true">
      </dxo-editing>
      
    </dx-data-grid>
  </div>
  <div class="button-container">
    <app-action-button
      *ngIf="canSeeApplyAndStraight40"
      label="APPLY"
      type="default"
      (ctmClick)="onApply()"
    >
    </app-action-button>
    <dx-check-box
      *ngIf="hasS40Role"
      text="Straight 40"
      [(value)]="straight40">
    </dx-check-box>
    <app-action-button
      *ngIf="canSeeCostOverride"
      label="Cost Override"
      type="default"
      (ctmClick)="onOpenCostOverride()">
    </app-action-button>
  </div>
  <div class="report-view" *ngIf="canSeeResultGrid">
    <dx-data-grid [dataSource]="gridDataSource"
                  [rowAlternationEnabled]="true"
                  [showBorders]="true"
                  [showColumnLines]="true"
                  [showRowLines]="true"
                  dataRowTemplate="dataRowTemplate"
                  id="gridContainer">
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxi-column caption="Milestone"
                  dataField="milestone"
                  cssClass="milestone-cell">
      </dxi-column>
      <dxi-column caption="Task"
                  dataField="task">
      </dxi-column>
      <dxi-column caption="CLM Revenue"
                  dataField="clmRevenue"
                  dataType="number">
      </dxi-column>
      <dxi-column caption="Real Cost"
                  dataField="realCost"
                  dataType="number">
      </dxi-column>
      <dxi-column caption="Final Revenue"
                  dataField="finalRevenue"
                  dataType="number">
      </dxi-column>
      <dxi-column caption="Diff"
                  dataField="diff"
                  dataType="number">
      </dxi-column>

      <ng-container *dxTemplate="let gridRow of 'dataRowTemplate'">
        <tr class="main-row" role="row">
          <td role="gridcell" class="milestone-cell">
            {{ gridRow.data.milestone }}
          </td>
          <td role="gridcell">
            {{ gridRow.data.task }}
          </td>
          <td role="gridcell">
            {{ gridRow.data.clmRevenue | number:'1.2-2' }}
          </td>
          <td role="gridcell">
            {{ gridRow.data.realCost | number:'1.2-2' }}
          </td>
          <td role="gridcell">
            {{ gridRow.data.finalRevenue | number:'1.2-2' }}
          </td>
          <td role="gridcell">
            {{ gridRow.data.diff | number:'1.2-2' }}
          </td>
        </tr>
      </ng-container>
    </dx-data-grid>
  </div>
  <div class="button-container" *ngIf="canSeeShowReport">
    <!-- PayCor hidden pending tests -->
    <!-- <app-action-button
      label="PayCor"
      type="default"
      (ctmClick)="onPayCor()"
    >
    </app-action-button> -->
    <app-action-button
      label="Show Report"
      type="default"
      (ctmClick)="onShowReport()"
    >
    </app-action-button>
  </div>

  <!-- Power BI Report Section -->
  <div class="report-section" *ngIf="isReportVisible && canSeeShowReport">
    <h3>Real Cost Report</h3>
    <powerbi-report
      [embedConfig]="reportConfig"
      [cssClassName]="'report-container'"
    >
    </powerbi-report>
  </div>

  <app-cost-override-popup
    [(visible)]="isCostOverridePopupVisible"
    [resources]="costOverrideResources"
    [isSaving]="isSavingCostOverrides"
    (saveOverrides)="onSaveCostOverrides($event)">
  </app-cost-override-popup>
</div>
